<template lang="pug">
  .component-selectize-icon
    selectize(v-if="options", :selectedValue="selectedValue" :options="options", value-field="iconName", :maxItems="maxItems" label-field="name", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Icon")
</template>

<script>
import Selectize from "../../../Selectize"
import BaseSelectize from './BaseSelectize'
import * as mdi from '@mdi/js'

export default {
  name: "SelectizeIcon",
  extends: BaseSelectize,
  components: {Selectize},
  data() {
    return {
      options: null,
      searchableFields: ['name']
    }
  },
  created() {

    const kebabize = (str) =>
      str.split('').map((letter, idx) => {
        return letter.toUpperCase() === letter
          ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
          : letter;
      }).join('');


    this.options = Object.entries(mdi).splice(1).map((icon) => {
      return {
        name: kebabize(icon[0].replace("mdi", "")),
        iconName: kebabize(icon[0]),
        id: kebabize(icon[0]),
        path: icon[1]
      }
    })
  },
  methods: {
    optionTemplate(item, escape) {
      return `<div class="selectable-item"><svg xmlns='http://www.w3.org/2000/svg'><path fill="currentColor" d="${item.path}"></path></svg><span>${item.name}</span></div>`
    },
    renderTemplate(item, escape) {
      return `<div class="selected-item"><svg xmlns='http://www.w3.org/2000/svg'><path fill="currentColor" d="${item.path}"></path></svg><span>${item.name}</span></div>`
    }
  },
  props: ['selectedValue']
}
</script>

<style lang="sass" rel="stylesheet/sass">
.component-selectize-icon
  .selected-item, .selectable-item
    display: flex
    align-items: center
    margin-top: 0.65em

    span
      margin-left: .5em

    svg
      height: 2em
      width: 2em

  .selected-item
    margin-top: 0.65em
</style>



// WEBPACK FOOTER //
// SelectizeIcon.vue?9e510ea2